export const PLAN_PAGE = 'src:pages:Plan';
export const SIGN_UP_SUCCESS_PAGE = 'src:pages:SignUpSuccess';
export const REACTIVATION_PAGE = 'src:pages:Reactivation';
export const REACTIVATION_SUCCESS_PAGE = 'src:pages:ReactivationSuccess';
